import { Button, Center, Text, VStack } from "@chakra-ui/react";
import { useConnectStripe } from "../../api/StripeApi";
import { useHandleModal } from "../../hooks/useHandleModal";
import { useCallback } from "react";

export const StripeNotConnectPage = () => {
  const { mutateAsync: connectStripe, isPending: isConnectingStripe } = useConnectStripe();
  const handleModal = useHandleModal();

  const showStripeDisabledModal = useCallback(() => {
    handleModal({
      title: "Stripe Has Been Temporarily Disabled",
      leftButtonTitle: "Cancel",
      rightButtonTitle: "OK",
    });
  }, [handleModal]);

  const handleClick = () => {
    // if (import.meta.env.MODE === "production") {
    //   showStripeDisabledModal();
    //   return;
    // }
    connectStripe().then((res) => {
      if (!res.redirectUrl) return console.error("No redirect URL returned from Stripe");
      window.location.href = res.redirectUrl;
    });
  };

  return (
    <Center pt={"10%"}>
      <VStack spacing={4}>
        <Text textStyle={"smMdSemi"} fontSize={"2xl"}>
          Connect your account to Stripe
        </Text>
        <Text>
          We use Stripe to make sure you get paid on time and keep your personal and bank
          details secure.
        </Text>
        <Button
          colorScheme="brandYellow"
          w={"48%"}
          onClick={handleClick}
          isLoading={isConnectingStripe}
        >
          <Text color={"brandBlue.800"} fontSize={"sm"}>
            Set Up Payments
          </Text>
        </Button>
      </VStack>
    </Center>
  );
};
